import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import { accountDeleteRequest } from "../utils/routes";
import toast from "react-hot-toast";
// import contactbg from "../assets/img/Contact.png";
// import emailicon from "../assets/img/email.svg";
// import phone from "../assets/img/telephone.svg";
// import map from "../assets/img/image.svg";
// import queryicon from "../assets/img/query icon.svg";
// import subjecticon from "../assets/img/subject icon.svg";
import { Rings } from "react-loader-spinner";
import Formimg from "../assets/img/contactform illustration.svg";
import closei from "../assets/img/Overlay close icon.svg";
import Meeting from "../assets/img/ill-1.png";
import Login from "./auth/Login";
import { Otp } from "./auth/OTP";

function DeleteAccount() {
  const [loading, setLoading] = useState(true);
  const [authentication, setAuthentication] = useState(false);
  const [isValidOTP, setIsValidOTP] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [getLoggedInUser, setGetLoggedInUser] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  setTimeout(() => {
    setLoading(false);
  }, [1000]);

  const submitRequest = () => {
    setLoading(true);
    var dto = {
      accountId: getLoggedInUser.accountId,
      reason: deleteReason,
    };
    const getUserRequestDTO = {
      method: "POST",
      body: JSON.stringify(dto),
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (deleteReason.length) {
      fetch(accountDeleteRequest, getUserRequestDTO)
        .then((res) => res.json())
        .then((result) => {
          console.log(result, "res");
          if (result.statusCode === 0) {
            toast.success(result.result);
            setAuthentication(false);
            setIsValidOTP(false);
          }
          setLoading(false);
        });
    } else {
      toast.dismiss();
      toast.error("Reason is required");
    }
  };

  return (
    <>
      {loading ? (
        <div className={loading === true ? "overlay" : " "}>
          <span id="loading">
            <Rings color="#91298c" height={160} width={160} />
          </span>
        </div>
      ) : null}
      <section className="faq__section-one">
        <div className="container">
          <div className="row m-0 align-items-center">
            <div className="col-lg-6 col-md-4  order-lg-0 order-md-0 order-1">
              <center>
                <div>
                  <img
                    className="img-fluid-hero mt-5"
                    src={Meeting}
                    style={{ maxWidth: 400, width: "100%" }}
                  ></img>
                </div>
              </center>
            </div>
            <div className="col-lg-6 col-md-8 order-lg-1 order-md-1 order-0 ">
              <section className="section" id="contactForm">
                <div className="container">
                  <div className="section-title mb-3">
                    <h3 className="mb-0">
                      Delete <span className="text-pri">Account</span>
                    </h3>
                    <small style={{ color: "#785d78" }}>
                      Enter your details below to Delete your OneZapp customer
                      account
                    </small>
                  </div>
                  <div className="card">
                    <div className="row m-0">
                      <div className="col-lg-8 col-md-12 mx-auto">
                        {!authentication ? (
                          <Login
                            setAuthentication={setAuthentication}
                            setGetLoggedInUser={setGetLoggedInUser}
                          />
                        ) : !isValidOTP ? (
                          <Otp
                            setIsValidOTP={setIsValidOTP}
                            setAuthentication={setAuthentication}
                            getLoggedInUser={getLoggedInUser}
                          />
                        ) : (
                          <>
                            <div className="form-group my-4">
                              <label className="inputfield d-flex mb-2">
                                Reason for Account Deletion?{" "}
                                <small
                                  className={`ms-1 ${
                                    !deleteReason.length
                                      ? "text-danger"
                                      : "text-success"
                                  }`}
                                >
                                  *
                                </small>
                              </label>

                              <textarea
                                required
                                className="form-control-msg"
                                placeholder="Enter your reason for account deletion..."
                                rows={5}
                                onChange={(e) =>
                                  setDeleteReason(e.target.value)
                                }
                              />
                            </div>
                            <div className="d-flex gap-3 justify-content-between">
                              <button
                                className="btn btn-secondary btn-rounded"
                                onClick={() => {
                                  setAuthentication(false);
                                  setIsValidOTP(false);
                                }}
                              >
                                Cancel Request
                              </button>
                              <button
                                onClick={submitRequest}
                                className="btn btn-contect"
                                type="button"
                              >
                                Submit
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      <div className="modal modal-centered" id="SuccessDropdown" role="dialog">
        <div className="modal-dialog modal-xl">
          <div
            className="modal-content modalIpad"
            style={{
              background: "#EFDFEE",
              borderRadius: "25px",
              marginTop: "0px",
            }}
          >
            <div className="modal-header">
              <h6
                className="modal-title"
                data-dismiss="modal"
                // style={{ backgroundColor: "#EFDFEE" }}
              >
                &nbsp;
              </h6>
              <button
                type="button"
                className=""
                data-dismiss="modal"
                style={{
                  background: "transparent",
                  border: "transparent",
                }}
                onClick={(e) => closeModal(e)}
              >
                <img src={closei}></img>
              </button>
            </div>
            <div className="modal-body ">
              <center>
                <img className="modal-img" src={Formimg}></img>
                <br></br>
                <br></br>
                <h3 style={{ color: "#fbb516", fontWeight: "500" }}>
                  Your "Account Deletion" request is successfully submitted!
                </h3>

                <p
                  className="modal-p"
                  style={{ fontWeight: "500", color: "#fff" }}
                >
                  Our team will respond back to you at earliest. We are happy to
                  serve
                  <br></br> you excellent customer experience.<br></br>
                </p>
              </center>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default DeleteAccount;
